import { Modal, Button } from 'react-bootstrap';
import { IEwtSummary, IDonorsPerMonthByAbo } from '../../../models';
import { CurrentUnmatchedViableDonorMatchesWrapper, DonorsPerMonthByAboWrapper, MonthsWaitWrapper, MonthsWaitWrapperScroll, SummaryWrapper } from '../styles';

interface IProps {
    show: boolean,
    summaryData: IEwtSummary,
    initialCount: { [key: string]: number, O: number, A: number, B: number, AB: number },
    donorsPerMonthByAbo: IDonorsPerMonthByAbo,
    onClose: () => void
}

const EwtDetails = (props: IProps) => {
    const renderMonthsWaitRows = () => {
        let results = [];

        let poolAccum = props.summaryData.lastCalcInitialPoolUsed;

        for (let i = 1; i <= parseInt(props.summaryData.lastCalcActualResult); i++) {
            poolAccum = poolAccum + props.summaryData.lastCalcAddedPerMonth;

            results.push(
                <div className='row' key={i}>
                    <div className='col-xs-12 col-lg-6'>{i}</div>
                    <div className='col-xs-12 col-lg-6'>{poolAccum}</div>
                </div>
            );
        }

        return results;
    };

    const isAboCompatible = (recipientAbo: string, donorAbo: string) => {
        switch( recipientAbo) {
            case 'O'    : return ['O'].includes(donorAbo);
            case 'A'    : return ['O', 'A'].includes(donorAbo);
            case 'B'    : return ['O', 'B'].includes(donorAbo);
            case 'AB'   : return ['O', 'A', 'B', 'AB'].includes(donorAbo);
        }
    }

    const getCompatibleSums = ( donorsCounts: IDonorsPerMonthByAbo, recipientAbo: string) => {
        let compatibleCurrent = 0;
        let compatibleLastYear = 0;

        donorsCounts.counts.forEach( count => {
            if( isAboCompatible(recipientAbo, count.abo) ) {
                compatibleCurrent  += count.countOfCurrent;
                compatibleLastYear += count.countOfLastYear;
            }
        });

        return { abo: null, compatibleCurrent, compatibleLastYear };
    }

    const { summaryData, initialCount, donorsPerMonthByAbo } = props;

    if (summaryData == null || initialCount == null || donorsPerMonthByAbo == null)
        return null;

    const compatibleSums   = getCompatibleSums(props.donorsPerMonthByAbo, props.summaryData.recipientAbo);
    const lastCalcDonorAbo = props.summaryData.lastCalcDonorAbo != 'DNK' ? props.summaryData.lastCalcDonorAbo : '';

    return (
        <>
            <Modal backdrop='static' bsSize='large' show={props.show} onHide={props.onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Estimated Wait Time Detail</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className='row'>
                        <div className='col-xs-4' style={{ paddingLeft: 7.5, paddingRight: 7.5 }}>
                            <SummaryWrapper className='table table-striped table-condensed' style={{ width: '90%', margin: '0 auto' }}>
                                <thead>
                                    <tr>
                                        <th colSpan={2} style={{ height: 56, verticalAlign: 'middle' }}>Summary</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Center CPR Score</td>
                                        <td>{(props.summaryData.lastCalcCprScore * 100).toFixed(1)}%</td>
                                    </tr>
                                    <tr>
                                        <td>Patient Alias</td>
                                        <td>{props.summaryData.recipientAlias}</td>
                                    </tr>
                                    <tr>
                                        <td>Patient ABO</td>
                                        <td>{props.summaryData.recipientAbo}</td>
                                    </tr>
                                    <tr>
                                        <td>Patient CPRA</td>
                                        <td>{props.summaryData.lastCalcCpra.toFixed(0)}</td>
                                    </tr>
                                    <tr>
                                        <td>Patient Days Exportable:</td>
                                        <td>{props.summaryData.lastCalcExportableDays}</td>
                                    </tr>
                                    <tr>
                                        <td>Intended Donor ABO</td>
                                        <td>{lastCalcDonorAbo} ({props.summaryData.lastCalcFavorability})</td>
                                    </tr>
                                    <tr>
                                        <td>Donors Needed</td>
                                        <td>{props.summaryData.lastCalcDonorsNeeded}</td>
                                    </tr>
                                    <tr>
                                        <td>Initial Pool</td>
                                        <td>{props.summaryData.lastCalcInitialPool} <span className='label label-default'>{props.summaryData.lastCalcInitialPoolStatus}</span></td>
                                    </tr>
                                    <tr>
                                        <td>Donors/mo</td>
                                        <td>{Math.round(props.summaryData.lastCalcAddedPerMonth)}</td>
                                    </tr>
                                    <tr>
                                        <td>Actual Calculated Result</td>
                                        <td>{props.summaryData.lastCalcRawEwt >= 60 ? '60+' : props.summaryData.lastCalcRawEwt} month(s)</td>
                                    </tr>
                                </tbody>
                            </SummaryWrapper>
                        </div>

                        <div className='col-xs-4' style={{ paddingLeft: 7.5, paddingRight: 7.5 }}>
                            <CurrentUnmatchedViableDonorMatchesWrapper className='table table-striped table-condensed' style={{ width: '90%', margin: '0 auto' }}>
                                <thead>
                                    <tr><th colSpan={3}>Current Unmatched Viable Donor Matches</th></tr>
                                    <tr>
                                        <th>R ABO</th>
                                        <th>ABO Matches</th>
                                        <th>Match Count</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>O</td>
                                        <td>O</td>
                                        <td>{props.initialCount.O}</td>
                                    </tr>
                                    <tr>
                                        <td>A</td>
                                        <td>O, A</td>
                                        <td>{props.initialCount.A}</td>
                                    </tr>
                                    <tr>
                                        <td>B</td>
                                        <td>O, B</td>
                                        <td>{props.initialCount.B}</td>
                                    </tr>
                                    <tr>
                                        <td>AB</td>
                                        <td>O, A, B, AB</td>
                                        <td>{props.initialCount.Ab}</td>
                                    </tr>
                                </tbody>
                            </CurrentUnmatchedViableDonorMatchesWrapper>
                        </div>

                        <div className='col-xs-4' style={{ paddingLeft: 7.5, paddingRight: 7.5 }}>
                            <MonthsWaitWrapper className='container-fluid'>
                                <div className='row' style={{ backgroundColor: '#123666', color: 'white', height: 56, display: 'flex', alignItems: 'center' }}>
                                    <div className='col-xs-12 col-lg-6'>Months Wait</div>
                                    <div className='col-xs-12 col-lg-6' style={{ paddingLeft: 0, paddingRight: 30 }}>Est Donors</div>
                                </div>
                                <div className='row'>
                                    <MonthsWaitWrapperScroll className='col-xs-12 col-lg-12'>
                                        <div className='row'>
                                            <div className='col-xs-12 col-lg-6'>Current</div>
                                            <div className='col-xs-12 col-lg-6'>{props.summaryData.lastCalcInitialPoolUsed}</div>
                                        </div>
                                        {renderMonthsWaitRows()}
                                    </MonthsWaitWrapperScroll>
                                </div>
                            </MonthsWaitWrapper>
                        </div>
                    </div>
                    <br />

                    <div className='row'>
                        <DonorsPerMonthByAboWrapper className='table table-striped table-condensed' style={{ width: '97%', margin: '0 auto' }}>
                            <thead>
                                <tr>
                                    <th colSpan={5}>Donors by ABO</th>
                                </tr>
                                <tr>
                                    <th>Donor ABO</th>
                                    <th>Compatible with {props.summaryData.recipientAbo}</th>
                                    <th>In Current Pool</th>
                                    <th>Total Last 12 Months</th>
                                    <th>Average per Month</th>
                                </tr>
                            </thead>
                            <tbody>
                                {props.donorsPerMonthByAbo.counts.map( count => {
                                    const isCompat  = isAboCompatible(props.summaryData.recipientAbo, count.abo);
                                    const className = isCompat ? 'label label-success' : 'label label-warning';
                                    return (
                                        <tr key={count.abo}>
                                            <td>{count.abo}</td>
                                            <td><span className={className}>{isCompat ? '✔' : '✖'}</span></td>
                                            <td>{count.countOfCurrent}</td>
                                            <td>{count.countOfLastYear}</td>
                                            <td>{Math.floor(count.countOfLastYear / 12)}</td>
                                        </tr>
                                    );
                                })}
                                <tr className='bg-success'>
                                    <td ><strong>ABO Compatible Donors</strong></td>
                                    <td>&nbsp;</td>
                                    <td>{compatibleSums.compatibleCurrent}</td>
                                    <td>{compatibleSums.compatibleLastYear}</td>
                                    <td>{Math.floor(compatibleSums.compatibleLastYear / 12)}</td>
                                </tr>
                            </tbody>
                        </DonorsPerMonthByAboWrapper>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button bsStyle='primary' onClick={props.onClose}>Close</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default EwtDetails;